var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone"},[_c('label',[_vm._t("label")],2),_c('div',{staticClass:"phone-screen"},[_c('div',{staticClass:"first-header"}),_c('div',{staticClass:"second-header"}),_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }